import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import Box from '@mui/system/Box';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/icons-material/TrendingUp": TrendingUpIcon, "@mui/system/Box": Box } } });
export default ClientProvider;
